export class SubmitFeedbackModel {
    public Fullname: string;
    public EmailAddress: string;
    public MobileNumber: string;
    public Message: string;
}
